import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '../views/Dashboard.vue'
// import Dinamica from '../views/Dinamica.vue'
// import Resultado from '../views/Resultado.vue'
// import MiCuenta from '../views/MiCuenta.vue'
// import Participaciones from '../views/Participaciones.vue'
import Aviso from '../views/Aviso.vue'
import LoginReportes from '../views/LoginReportes.vue'


import { auth } from '../firebase'

Vue.use(VueRouter)

const routes = [
    // {
    //     path: '/',
    //     name: 'Dashboard',
    //     component: Dashboard,
    //     meta: {
    //         requiresAuth: true
    //     }
    // },
    {
        path: '/',
        name: 'Login',
        component: () =>
            import ( /* webpackChunkName: "login" */ '../views/Login.vue')
    },


]

const router = new VueRouter({
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return {
                selector: to.hash
            }
        }
        return { x: 0, y: 0 }
    },
    base: process.env.BASE_URL,
    routes
})

// navigation guard to check for logged in users
router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
    const requiresAuthAdmin = to.matched.some(x => x.meta.requiresAuthAdmin)

    const requiresNoTicket = to.matched.some(x => x.meta.requiresNoTicket)
    const requiresTicket = to.matched.some(x => x.meta.requiresTicket)

    let user;

    if (requiresAuth) {
        user = localStorage.getItem("user_arreglalo");
        user = JSON.parse(user);
        console.log(user)
    } else if (requiresAuthAdmin) {
        user = localStorage.getItem("user_arreglalo_lector");
        user = JSON.parse(user);
        console.log(user)
    }



    if (requiresAuth === true && user == null) {
        next('/administrador')
    } else if (requiresAuthAdmin === true && user == null) {
        next('/lector')
    } else {

        // if (user != null && requiresAuth == true) {
        //     next('/administrador/dashboard')
        // } else if (user != null && requiresAuthAdmin == true) {
        //     next('/lector/scan')
        // }


        next()
    }
})

export default router